import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';

/** Whether Generate high res can render a Seedance 2.5 draft from a workflow's node, and until when. */
export interface Seedance25DraftAvailability {
  available: boolean;
  /** ISO 8601; present when available. */
  expiresAt?: string;
}

export const getSeedance25DraftAvailability = async (workflowId: string, asset: { id?: string; url?: string }) => {
  const res = await safeAxios.get<Seedance25DraftAvailability>(API_ROUTES.models.seedance25DraftAvailability(), {
    params: { workflowId, assetId: asset.id || undefined, assetUrl: asset.url || undefined },
  });
  return res.data;
};
